import React from 'react';
import PropTypes from 'prop-types';
import { prettyNumber, metersToMiles, squareMetersToAcres } from '../../../../../lib/utils';
import DataPoint from '../DataPoint';
import Divider from '../Divider';

export default function AreaStats(props) {
  const area = props.feature;

  const hasGeometry = () => {
    return area && area.geometry && area.geometry.coordinates;
  };

  const getArea = () => {
    if (
      hasGeometry() &&
      area.properties != null &&
      area.properties.area != null &&
      area.properties.area !== 0
    ) {
      return prettyNumber(squareMetersToAcres(area.properties.area), 2);
    }
    return '--';
  };

  const getPerimeter = () => {
    if (
      hasGeometry() &&
      area.properties != null &&
      area.properties.distance != null &&
      area.properties.distance !== 0
    ) {
      return prettyNumber(metersToMiles(area.properties.distance), 2);
    }
    return '--';
  };

  return (
    <>
      <DataPoint title='Area'>
        { getArea() + ' acres'}
      </DataPoint>
      <Divider margin={24} />
      <DataPoint title='Perimeter'>{ getPerimeter() + ' miles'}</DataPoint>
    </>
  );
}

AreaStats.propTypes = {
  feature: PropTypes.object,
};
